import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const DetallesResultados = ({ resultado, onClose }) => {
    const [niveles, setNiveles] = useState([]);
    const [error, setError] = useState(null);

    const getAuthToken = () => {
        return localStorage.getItem('token');
    };

    function formatTiempo(segundos) {
        const horas = Math.floor(segundos / 3600);
        const minutos = Math.floor((segundos % 3600) / 60);
        const segs = segundos % 60;
    
        return [
          horas.toString().padStart(2, '0'),
          minutos.toString().padStart(2, '0'),
          segs.toString().padStart(2, '0')
        ].join(':');
      }

    const fetchNivelesUsuario = async () => {
        try {
            const authToken = getAuthToken();
            const response = await axios.get(`${API_BASE_URL}/api/resultados/usuario/${resultado.id}`, {
                headers: { Authorization: `Bearer ${authToken}` }
            });
            setNiveles(response.data);
        } catch (err) {
            setError('Error al cargar los niveles del usuario');
            console.error('Error al cargar los niveles del usuario:', err);
        }
    };

    useEffect(() => {
        fetchNivelesUsuario();
    }, [resultado.id]);

    return (
        <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start">
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                                <h3 className="text-lg leading-6 font-medium text-gray-900">Detalles de Resultados de {resultado.nombre}</h3>
                                <div className="mt-2">
                                    {error ? (
                                        <p className="text-red-500">{error}</p>
                                    ) : (
                                        <div className="overflow-x-auto">
                                            <table className="w-full bg-white">
                                                <thead>
                                                    <tr className="bg-green-700 text-white">
                                                        <th className="px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">Nivel</th>
                                                        <th className="px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">Aciertos</th>
                                                        <th className="px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">Con ajustes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {niveles.map((nivel, index) => (
                                                        <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}>
                                                            <td className="border px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">{nivel.nombre}</td>
                                                            <td className="border px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">{nivel.respuestas_correctas}</td>
                                                            <td className="border px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">{nivel.respuestas_incorrectas}</td>
                                                            
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                        <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={onClose}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetallesResultados;